import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  setSecondaryTargetDevice,
  fetchAndSelectSecondary,
  replaceDevice,
  retireDevice,
  enableFAT,
  enableOAT,
  sendShelfIdentificationCommand,
  sendDiscoveryCommand,
  sendScale2Command,
  SCALE2_COMMANDS,
} from '../actions/device';
import {
  startReplacement,
  startRetire,
  setRetireReason,
  returnToMenu,
  startReprovisionDevice,
  startEnableFAT,
  startEnableOAT,
  startProvision,
  startIdentification,
  startDiscovery,
  startScale2Tare,
  startScale2Calibrate,
  startScale2Discovery,
} from '../actions/management';

import ManagementPage from '../components/pages/ManagementPage';
import ReplacementPage from '../components/pages/ReplacementPage';
import RetirePage from '../components/pages/RetirePage';
import WizardContainer from './WizardContainer';
import FATPage from '../components/pages/FATPage';
import OATPage from '../components/pages/OATPage';
import IdentificationPage from '../components/pages/IdentificationPage';
import DiscoveryPage from '../components/pages/DiscoveryPage';
import Scale2TarePage from '../components/pages/Scale2TarePage';
import Scale2CalibratePage from '../components/pages/Scale2CalibratePage';
import Scale2DiscoveryPage from '../components/pages/Scale2DiscoveryPage';

class ManagementContainer extends Component {
  componentDidMount() {
    this.props.setSecondaryTargetDevice(null);
  }

  render() {
    const {
      state,
      target,
      organization,
      replacement,
      replaceDevice,
      retireDevice,
      startReplacement,
      startRetire,
      fetchAndSelectSecondary,
      setSecondaryTargetDevice,
      returnToMenu,
      isRoot,
      startReprovisionDevice,
      setRetireReason,
      startEnableFAT,
      enableFAT,
      startEnableOAT,
      enableOAT,
      startProvision,
      startIdentification,
      sendShelfIdentificationCommand,
      retiredReason,
      startDiscovery,
      sendDiscoveryCommand,
      startScale2Tare,
      startScale2Calibrate,
      startScale2Discovery,
      sendScale2Command,
    } = this.props;

    switch (state) {
      case 'REPLACEMENT':
        return (
          <ReplacementPage
            target={target}
            replacement={replacement}
            fetchReplacement={fetchAndSelectSecondary}
            cancel={() => {
              setSecondaryTargetDevice(null);
              returnToMenu();
            }}
            replace={async () => {
              await replaceDevice(target.id, replacement.id);
            }}
          />
        );
      case 'RETIRE':
        return (
          <RetirePage
            target={target}
            cancel={returnToMenu}
            retiredReason={retiredReason}
            retire={async () => {
              await retireDevice(target.id, retiredReason);
            }}
            onChange={event => {
              const newValue = event.target.value;
              setRetireReason(newValue);
            }}
          />
        );
      case 'REPROVISION':
        return <WizardContainer isReprovision={true} />;
      case 'ENABLE_FAT':
        return (
          <FATPage
            target={target}
            organization={organization}
            cancel={returnToMenu}
            enableFAT={async () => {
              await enableFAT(target.deviceCode, organization);
            }}
          />
        );
      case 'ENABLE_OAT':
        return (
          <OATPage
            target={target}
            organization={organization}
            cancel={returnToMenu}
            enableOAT={async () => {
              await enableOAT(target.deviceCode, organization);
              window.location.href = '/' + target.deviceCode;
            }}
          />
        );
      case 'PROVISION':
        return <WizardContainer />;

      case 'IDENTIFICATION':
        return (
          <IdentificationPage
            target={target}
            organization={organization}
            cancel={returnToMenu}
            startShelfIdentification={async () => {
              await sendShelfIdentificationCommand(
                target.deviceCode,
                'startIdentifyShelves'
              );
            }}
            stopShelfIdentification={async () => {
              await sendShelfIdentificationCommand(
                target.deviceCode,
                'stopIdentifyShelves'
              );
              window.location.href = '/' + target.deviceCode;
            }}
          />
        );

      case 'DISCOVERY':
        return (
          <DiscoveryPage
            target={target}
            organization={organization}
            cancel={returnToMenu}
            startDiscoveryMode={async () => {
              await sendDiscoveryCommand(
                target.deviceCode,
                'startScaleSlotDiscoveryMode'
              );
            }}
            stopDiscoveryMode={async () => {
              await sendDiscoveryCommand(
                target.deviceCode,
                'endScaleSlotDiscoveryMode'
              );
              window.location.href = '/' + target.deviceCode;
            }}
          />
        );

      case 'SCALE2_DISCOVERY':
        return (
          <Scale2DiscoveryPage
            target={target}
            organization={organization}
            message={this.props.scale2Message}
            cancel={returnToMenu}
            startDiscovery={async () => {
              await sendScale2Command(
                target.deviceCode,
                SCALE2_COMMANDS.startDiscovery
              );
            }}
            stopDiscovery={async () => {
              await sendScale2Command(
                target.deviceCode,
                SCALE2_COMMANDS.endDiscovery
              );
              window.location.href = '/' + target.deviceCode;
            }}
          />
        );
      case 'SCALE2_TARE':
        return (
          <Scale2TarePage
            target={target}
            organization={organization}
            message={this.props.scale2Message}
            cancel={returnToMenu}
            startTare={async () => {
              await sendScale2Command(
                target.deviceCode,
                SCALE2_COMMANDS.startTare
              );
            }}
            tareLanes={async position => {
              // position null = every lane, { shelfId, slotId } = that lane only
              await sendScale2Command(
                target.deviceCode,
                SCALE2_COMMANDS.tareLanes,
                position || {}
              );
            }}
            stopTare={async () => {
              await sendScale2Command(
                target.deviceCode,
                SCALE2_COMMANDS.endTare
              );
              window.location.href = '/' + target.deviceCode;
            }}
          />
        );
      case 'SCALE2_CALIBRATE':
        return (
          <Scale2CalibratePage
            target={target}
            organization={organization}
            message={this.props.scale2Message}
            cancel={returnToMenu}
            startCalibrate={async () => {
              await sendScale2Command(
                target.deviceCode,
                SCALE2_COMMANDS.startCalibrate
              );
            }}
            calibrateLane={async (shelfId, slotId, weight) => {
              await sendScale2Command(
                target.deviceCode,
                SCALE2_COMMANDS.calibrateLane,
                {
                  shelfId,
                  slotId,
                  weight,
                }
              );
            }}
            endCalibrate={async () => {
              await sendScale2Command(
                target.deviceCode,
                SCALE2_COMMANDS.endCalibrate
              );
              window.location.href = '/' + target.deviceCode;
            }}
          />
        );
      default:
        return (
          <ManagementPage
            isRoot={isRoot}
            target={target}
            startReplacement={startReplacement}
            startRetire={startRetire}
            startReprovisionDevice={startReprovisionDevice}
            startEnableFAT={startEnableFAT}
            startEnableOAT={startEnableOAT}
            startProvision={startProvision}
            startIdentification={startIdentification}
            startDiscovery={startDiscovery}
            startScale2Tare={startScale2Tare}
            startScale2Calibrate={startScale2Calibrate}
            startScale2Discovery={startScale2Discovery}
          />
        );
    }
  }
}

const mapStateToProps = ({ device, management }) => ({
  target: device.target ? device.devices[device.target] : null,
  organization: device.devices[device.target].deviceOrganization,
  replacement: device.secondaryTarget
    ? device.devices[device.secondaryTarget]
    : null,
  state: management.state,
  retiredReason: management.retiredReason,
  scale2Message: management.scale2Message,
});

const mapDispatchToProps = {
  setSecondaryTargetDevice,
  startReplacement,
  startRetire,
  replaceDevice,
  retireDevice,
  fetchAndSelectSecondary,
  returnToMenu,
  startReprovisionDevice,
  startEnableFAT,
  enableFAT,
  startEnableOAT,
  enableOAT,
  startProvision,
  startIdentification,
  sendShelfIdentificationCommand,
  setRetireReason,
  startDiscovery,
  sendDiscoveryCommand,
  startScale2Tare,
  startScale2Calibrate,
  startScale2Discovery,
  sendScale2Command,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagementContainer);
